import React, {
  useState,
  useEffect,
} from "react";

import { employeeIdOf } from "../utils/payrollHelpers";

const PayrollAdjustmentModal = ({
  open,
  employee,
  payrollMonth,
  loading = false,
  onClose,
  onSubmit,
  onApprove,
}) => {
  const [type, setType] =
    useState("BONUS");

  const [amount, setAmount] =
    useState("");

  const [reason, setReason] =
    useState("");

  const [savedDraft, setSavedDraft] = useState(null);
  const [error, setError] = useState("");
  const employeeId = employeeIdOf(employee);
  const snapshot = employee?.employeeSnapshot || employee || {};
  useEffect(() => {
    if (open) { setType("BONUS"); setAmount(""); setReason(""); setError(""); setSavedDraft(null); }
  }, [open, employeeId, payrollMonth]);
  if (!open) return null;

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    if (savedDraft) {
      try { await onApprove?.(savedDraft._id); } catch (failure) { setError(failure.message || "Could not approve this adjustment."); }
      return;
    }
    if (!employeeId) { setError("This payroll record is missing its employee reference. Close this dialog and refresh the register."); return; }
    if (!Number.isFinite(Number(amount)) || Number(amount) <= 0) { setError("Enter an amount greater than zero."); return; }
    if (!reason.trim()) { setError("Enter a reason for this adjustment."); return; }
    try { const result = await onSubmit?.({ employeeId, payrollMonth, type, amount: Number(amount), reason: reason.trim() }); if (result?._id) setSavedDraft(result); }
    catch (failure) { setError(failure.message || "Could not save this adjustment. Please try again."); }
  };

  return (
    <div className="se-payroll-modal-backdrop">
      <div className="se-payroll-modal" role="dialog" aria-modal="true" aria-labelledby="payroll-adjustment-title">
        <div className="se-payroll-modal__header">
          <div>
            <h2 id="payroll-adjustment-title">
              Payroll Adjustment
            </h2>

            <p>
              {snapshot.employeeName ||
                snapshot.fullName ||
                "Employee"}
            </p>
          </div>

          <button
            type="button"
            aria-label="Close adjustment"
            disabled={loading}
            className="se-payroll-modal__close"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        <form onSubmit={submit}>
          {error && <div role="alert" className="se-payroll-form-alert"><strong>Adjustment wasn’t saved</strong><p>{error}</p></div>}
          <p className="se-payroll-form-note">{payrollMonth} · Saved as a draft for approval. The payroll must be recalculated after approval.</p>
          {savedDraft && <div role="status" className="se-payroll-form-success"><strong>Draft adjustment saved</strong><p>Approve this adjustment, then regenerate the payroll run to include it.</p></div>}
          <fieldset className="se-payroll-form-fields" disabled={loading || Boolean(savedDraft)}><div className="se-payroll-form-grid">
            <label className="se-payroll-form-full">
              <span>
                Adjustment Type
              </span>

              <select
                value={type}
                onChange={(event) =>
                  setType(
                    event.target.value
                  )
                }
              >
                <option value="BONUS">
                  Bonus
                </option>

                <option value="INCENTIVE">
                  Incentive
                </option>

                <option value="ARREAR">
                  Arrear
                </option>

                <option value="REIMBURSEMENT">
                  Reimbursement
                </option>

                <option value="OTHER_EARNING">
                  Other Earning
                </option>

                <option value="OTHER_DEDUCTION">
                  Other Deduction
                </option>

                <option value="ADVANCE_RECOVERY">
                  Advance Recovery
                </option>

                <option value="LOAN_RECOVERY">
                  Loan Recovery
                </option>
              </select>
            </label>

            <label className="se-payroll-form-full">
              <span>Amount</span>

              <input
                type="number"
                min="0.01"
                step="0.01"
                required
                value={amount}
                onChange={(event) =>
                  setAmount(
                    event.target.value
                  )
                }
              />
            </label>

            <label className="se-payroll-form-full">
              <span>Reason</span>

              <textarea
                rows="3"
                required
                value={reason}
                onChange={(event) =>
                  setReason(
                    event.target.value
                  )
                }
              />
            </label>
          </div>

          </fieldset>
          <div className="se-payroll-modal__footer">
            <button
              type="button"
              className="se-payroll-btn se-payroll-btn--secondary"
              onClick={onClose}
            >
              {savedDraft ? "Close" : "Cancel"}
            </button>

            <button
              type="submit"
              className="se-payroll-btn se-payroll-btn--primary"
              disabled={loading || !employeeId}
            >
              {loading
                ? "Saving..."
                : savedDraft ? "Approve Adjustment" : "Save Draft Adjustment"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PayrollAdjustmentModal;